const Tools = 
[
    'SDL Trados',
    'Wordfast',
    'Deja Vu',
    'OmegaT',
    'Passolo',
    'Multicorporal',
    'Across',
    'Alchemy Catalyst',
    'TransSuite2000',
    'Transit',
    'MetaTexis',
    'LingoTek',
    'J-CAT',
    'IBM-CAT tool'
]

export default Tools